import { Component, OnInit, Input, EventEmitter, HostListener, ElementRef, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileUploadComponent,
            multi: true
        }
    ],
    styleUrls: ['./file-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent implements OnInit {
  @Input() progress;
  onChange: Function;
  file: File | null = null;

  @HostListener('change', ['$event.target.files']) emitFiles( event: FileList ) {
    const file = event && event.item(0);
    // console.log(file);
    console.log("listener");
    this.onChange(file);
    this.file = file;
    console.log(this.host);
  }

  constructor( private host: ElementRef<HTMLInputElement>, private _renderer: Renderer2 ) {
  }

  writeValue( value: null ) {
    // clear file input

 
    // this.host.nativeElement.value = '';
    this.file = null;
    
  }

  clearInput() {
    this.host.nativeElement.value = '';
    // this._renderer.setProperty(this.host.nativeElement, 'value', '');
    this.file = null;
    this.onChange(this.file);
  }



  registerOnChange( fn: Function ) {
    
    this.onChange = fn;
  }

  registerOnTouched( fn: Function ) {
   
  }
  ngOnInit() {
  }

}
